import { type RoadStatusLayerOptions } from '../Layers/Layers.types';
import { RoadStatusLayer } from '../Layers/RoadStatusLayer';
import TravelTimeV2 from '../PopupTemplates/TravelTimeV2';
import { TravelTimeV2SectionSource } from '../Sources/TravelTimeV2SectionSource';
import { TravelTimeV2StatusSource } from '../Sources/TravelTimeV2StatusSource';

const mappedStatuses = {
    unknown: 0,
    freeflow: 1,
    heavy: 2,
    congested: 3,
    impossible: 4,
    closed: 5,
};

/**
 * TomTom travel-time layer.
 */
export const travelTimeV2 = function (region: string, options?: RoadStatusLayerOptions): RoadStatusLayer {
    const sectionSource = new TravelTimeV2SectionSource(region, { updateInterval: 60, retryInterval: 10 });
    const statusSource = new TravelTimeV2StatusSource(region, { updateInterval: 60, retryInterval: 10 });

    const defaultOptions: RoadStatusLayerOptions = {
        offsetBy: 2,
        color: {
            unknown: '#ccc',
            freeflow: '#17D8A8',
            heavy: '#FFB544',
            congested: '#F23C32',
            impossible: '#811F1F',
            closed: '#c0bebe',
        },
        filterByZoom: function (feature, zoom /** Min: 2 (zoomed out), Max: 13 (zoomed in)*/) {
            const tier = feature.properties.zoomLevel;
            // Tiers start at 1. Anything else means the route name carried no usable
            // road class, so the segment has no zoom tier to be shown at.
            if (typeof tier !== 'number' || tier < 1) {
                return false;
            }
            if (zoom <= 4) {
                return tier === 1;
            }
            if (zoom <= 5) {
                return tier <= 2;
            }
            if (zoom <= 6) {
                return tier <= 3;
            }
            if (zoom <= 7) {
                return tier <= 4;
            }
            if (zoom <= 8) {
                return tier <= 5;
            }
            if (zoom <= 9) {
                return tier <= 6;
            }
            if (zoom <= 10) {
                return tier <= 7;
            }
            return true;
        },
        getStatus: function (section) {
            return section.status;
        },
        weightByZoom: function (feature, zoom) {
            if (zoom >= 12) {
                return 3.5;
            }
            return 2.5;
        },
        getStatusCode: function (status) {
            return mappedStatuses[status];
        },
        source: sectionSource,
        statusSource: statusSource,
        missingStatusMeansFreeflow: true,
        tooltipTemplate: TravelTimeV2,
    };

    return new RoadStatusLayer({ ...defaultOptions, ...options });
};
